import $ from 'jquery';

function onCheckboxChange() {
    const $inputs = $('.js-show-representative input');
    if ($inputs.length < 1) return;

    $inputs.on('change', function () {
        const $this = $(this);
        const isChecked = $this.prop('checked');
        $this.closest('.js-complainant').find('.js-representative').toggle(isChecked);
    });
}

export function initEvents() {
    onCheckboxChange();
}

export default {
    initEvents
};
